import { GtmEventAction } from "@obg/gtm.types/adaptive";
import { CoreUiInteractionEvent, generateTrackingKey } from "@obg/ngx.core";

import { TrackingContext } from "./tracking.model";

export const CORE_UI_INTERACTION_TRACKING_MAP: Record<string, any> = {
	[generateTrackingKey(TrackingContext.HeaderInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "TopNavigationClick",
	},
	[generateTrackingKey(TrackingContext.HeaderInteractionContext, CoreUiInteractionEvent.Click)]: {
		event: "TopNavigationClick",
	},
	[generateTrackingKey(TrackingContext.BrandHeaderLogoContext, CoreUiInteractionEvent.Click)]: {
		event: "BrandHeaderLogo",
	},
	[generateTrackingKey(TrackingContext.FooterInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "BottomNavigationClick",
	},
	[generateTrackingKey(TrackingContext.ForgotPasswordInteractionContext, CoreUiInteractionEvent.Submit)]: {
		event: "LoginPasswordFormSubmit",
	},
	[generateTrackingKey(TrackingContext.LoginInteractionContext, CoreUiInteractionEvent.Open)]: {
		event: "LoginFormOpen",
	},
	[generateTrackingKey(TrackingContext.QuickDepositInteractionContext, CoreUiInteractionEvent.Submit)]: {
		event: "QuickDeposit",
	},
	[generateTrackingKey(TrackingContext.GameFrameInteractionContext, CoreUiInteractionEvent.Click)]: {
		event: "GameFrameClick",
	},
	[generateTrackingKey(TrackingContext.LanguageSelectorInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: "BottomNavigationClick",
	},
	[generateTrackingKey(TrackingContext.BannerInteractionContext, CoreUiInteractionEvent.Click)]: {
		event: "BannerClick",
	},
	[generateTrackingKey(TrackingContext.AcceptTCInteractionContext, CoreUiInteractionEvent.Submit)]: {
		event: "AcceptTC",
	},
	[generateTrackingKey(TrackingContext.BurgerMenuInteractionContext, CoreUiInteractionEvent.Navigate)]: {
		event: GtmEventAction.BurgerMenuClick,
	},
	[generateTrackingKey(TrackingContext.BottomBarTabInteractionContext, CoreUiInteractionEvent.Click)]: {
		event: "GameBottomNavigationClick",
	},
	[generateTrackingKey(TrackingContext.BottomVPVInteractionContext, CoreUiInteractionEvent.Click)]: {
		event: "CloseNavigationPopup",
	},
};
